/**
 * Removes properties with the string value "null" from the given object.
 *
 * @param {Object} obj - The object from which properties with the value "null" will be removed.
 * @returns {Object} The modified object with properties having the value "null" removed.
 */
export default function removeNull<T>(object: T | undefined | null): T | undefined {
  if (object == null) return undefined
  let cleanObject = { ...object }
  for (let key in cleanObject) {
    if (cleanObject[key] === `null`) {
      delete cleanObject[key]
    }
  }
  return cleanObject
}
